import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiGateway } from 'api/apiHost';
import {
  KidsHubGetPastPerformanceDataResponse,
  KidsHubGetTableParams,
  KidsHubGetTableResponse,
  KidshubGetPastPerformanceDataParams,
  PredictivePerformanceResponse,
  PredictivePerformanceRequestParams,
} from 'model/KidsHub';

export const apiSlice = createApi({
  reducerPath: 'kidshubApi',
  baseQuery: fetchBaseQuery({ baseUrl: apiGateway.proxyPath }),
  endpoints: (builder) => ({
    getTableData: builder.query<KidsHubGetTableResponse, KidsHubGetTableParams>({
      query: (body) => ({ url: '/funds/kidhub/', method: 'POST', body }),
    }),

    getPastPerformanceData: builder.query<
      KidsHubGetPastPerformanceDataResponse,
      KidshubGetPastPerformanceDataParams
    >({
      query: (body) => ({ url: '/funds/performance/past', method: 'POST', body }),
    }),
    getPredictivePerformanceData: builder.query<
      PredictivePerformanceResponse,
      PredictivePerformanceRequestParams
    >({
      query: (body) => ({ url: '/funds/performance/predicted', method: 'POST', body }),
    }),
  }),
});

export const {
  useGetTableDataQuery,
  useGetPastPerformanceDataQuery,
  useLazyGetPredictivePerformanceDataQuery,
} = apiSlice;
